// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__pwhjA","part":"default_part__9CV4e","cursored":"default_cursored__EXI12","active":"default_active__rFny4"};